import { EventArgs, EventFunction } from "./EventArgs";

/**
 * Object for eventlist.
 * @hidden
 */
export class EventObject<TSender> {

    /**
     * Create a new EventObject.
     * @param func Script or function.
     * @param prediction Function which checks if script has to be executed.
     * @param resolve True if the script has to be resolved.
     */
    constructor(
        public func: (string | EventFunction<TSender>),
        public prediction?: (sender: TSender, args: EventArgs<TSender>) => boolean,
        public resolve?: boolean,
        public executeOnce?: boolean
    ) {
    }
}